import SimpleBreadcrumbsPage from '../../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../../shared/analytics/module-list';
import { pagesConfig } from '../../../../shared/pages-config';
import GroupTemplateFormLayout from './group-template-form-layout';

export default function CreateGroupTemplatePage() {
  return (
    <SimpleBreadcrumbsPage
      isSubPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        {
          label: pagesConfig.groupTemplates.name,
          path: pagesConfig.groupTemplates.link,
        },
      ]}
    >
      <GroupTemplateFormLayout title={pagesConfig.createGroupTemplate.name} />
    </SimpleBreadcrumbsPage>
  );
}
